import { render, staticRenderFns } from "./ConsentFormModal.vue?vue&type=template&id=33966532&scoped=true&"
import script from "./ConsentFormModal.vue?vue&type=script&lang=ts&"
export * from "./ConsentFormModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConsentFormModal.vue?vue&type=style&index=0&id=33966532&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33966532",
  null
  
)

export default component.exports